module.exports = __webpack_public_path__ + "static/img/8.ff269df.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/2/eng/8.png
// module id = wK0r
// module chunks = 0